"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mround_1 = require("./mround");
var precisionsz = ['', '.0', '.00', '.000', '.0000', '.00000', '.000000', '.0000000', '.00000000'];
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function fmoney(value, forcezeros, precision) {
    if (precision === void 0) { precision = 2; }
    if (value === null) {
        return '';
    }
    // const s = value.toFixed(2);
    // let s = mround(value, precision).toFixed(precision);
    if (value % 1 === 0) {
        if (forcezeros) {
            return value.toString() + precisionsz[precision].replace('.', ',');
        }
        else {
            return value.toString();
        }
    }
    var s = mround_1.default(value, precision).toFixed(precision);
    if (forcezeros) {
        return s.replace('.', ',');
    }
    else {
        return s.replace(precisionsz[precision], '').replace('.', ',');
    }
}
exports.default = fmoney;
//# sourceMappingURL=fmoney.js.map